import type { ClinicalEpisode } from './types';
export interface ScopedEncounter {
  id: string;
  patient_id?: string | null;
  pregnancy_id?: string | null;
  allowed_subject_ids?: string[];
}
/** Old maternal snapshots remain compatible; unknown or newborn encounters fail closed without explicit subject scope. */
export function encounterAllowsSubject(
  encounter: ScopedEncounter | undefined,
  episode: ClinicalEpisode,
  subjectId: string,
): boolean {
  if (!encounter) return false;
  if (encounter.allowed_subject_ids) return encounter.allowed_subject_ids.includes(subjectId);
  return (
    encounter.pregnancy_id === episode.pregnancy_id &&
    (!encounter.patient_id || encounter.patient_id === episode.patient_id)
  );
}
